import { useEffect, useState } from "react";
import { noImageHandle } from "../../../components/CommonMethod";
import Slider from "react-slick";
import { ASSET_ENDPOINT, fetchData, PAGE_TESTIMONIALS } from "../../../components/Service";

const SliderTestimonials = ({ page }) => {
    const [testimonials, setTestimonials] = useState([]);

    const options = {
        dots: true,
        arrows: false,
        infinite: false,
        autoplay: true,
        autoplaySpeed: 2500,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        variableHeight: true,
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    dots: true,
                }
            },
        ]
    };

    useEffect(() => {
        fetchData(`${PAGE_TESTIMONIALS}/${page}`, 'GET', '', false, false, (res) => {
            if (res.records && res.records.length > 0) {
                const pairs = [];
                for (let i = 0; i < res.records.length; i += 2) {
                    const first = res.records[i];
                    const second = res.records[i + 1] !== undefined ? res.records[i + 1] : res.records[0];
                    pairs.push([first, second]);
                }
                setTestimonials(pairs);
            }
        });
    }, [page])

    return (
        <section className="home-section5">
            <object type="image/svg+xml" className="homebg-cover" data="images/vector/shape3.svg" aria-hidden="true"></object>
            <div className="container container-1040 position-relative">
                <div className="row">
                    <div className="col-sm-12 col-lg-7">
                        <div className="d-flex align-items-start justify-content-center">
                            <svg className="icon mmwh-35 sm-mmwh-28 text-lime">
                                <use href="#icon_subtract"></use>
                            </svg>
                            <div className="px-3">
                                <h2 className="fw-bold mb-3 f-28_size">Discover how we've helped students succeed with us</h2>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="mt-5" id="testimonialSlider">
                    <Slider {...options}>
                        {testimonials.map(([first, second], key) => {
                            return <div key={key} className="position-relative">
                                <div className="col-sm-12">
                                    <div className={'card-limebar'}>
                                        <div className="card-innerbar">
                                            <img src={first.image ? ASSET_ENDPOINT + first.image : 'images/fly.png'} onError={noImageHandle} alt="fly" />
                                            <div className="card-limebar-inn">
                                                <div dangerouslySetInnerHTML={{ __html: first.description }} />
                                                <div className="fw-bold d-block mt-1 quote-cite">- {first.name} - <i className="fw-normal">{first.user ? first.user.roleName : 'Student'}</i> </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-12 mt-4">
                                    <div className={'card-skybar ms-auto'}>
                                        <div className="card-innerbar">
                                            <div className="card-limebar-inn">
                                                <div dangerouslySetInnerHTML={{ __html: second.description }} />
                                                <div className="fw-bold d-block mt-1 quote-cite">- {second.name} <i className="fw-normal">{second.user ? second.user.roleName : 'Student'}</i></div>
                                            </div>
                                            <img src={second.image ? ASSET_ENDPOINT + second.image : 'images/student.png'} onError={noImageHandle} alt="student" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        })}
                    </Slider>
                </div>
            </div>
        </section>
    )
}

export default SliderTestimonials